export default __webpack_public_path__ + "static/media/tour-access-code.d3ab4049.svg";